import LocaleSelect from './localeselect'
export default LocaleSelect
